/*!
 * Copyright © 2026. Verizon Connect Ireland Limited. All rights reserved.
 */

import { Pipe, PipeTransform } from '@angular/core';

import { ESpeedUnits } from '../../../core/models';
import { SpeedConvertPipe } from './speed-convert.pipe';

/**
 * Converts a speed range string (e.g. "30 - 50") from km/h to the target unit.
 * Each numeric value in the string is converted and rounded independently.
 * Non-range strings are returned as-is.
 */
@Pipe({
  name: 'speedRangeConvert'
})
export class SpeedRangeConvertPipe implements PipeTransform {
  private readonly _speedConvert = new SpeedConvertPipe();

  transform(rangeDisplay: string | null | undefined, speedUnits: ESpeedUnits): string {
    if (!rangeDisplay) return '';
    return rangeDisplay.replace(/\d+/g, match => {
      const converted = this._speedConvert.transform(Number(match), speedUnits);
      return Math.round(converted).toString();
    });
  }
}
